import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
    otpToken: string | null;
    expiresInSeconds: number | null;
    devOtp: string | null;
    token: string | null;
    isAuthenticated: boolean;
}

const storedToken =
    localStorage.getItem("journey_token");

const initialState: AuthState = {
    otpToken: null,
    expiresInSeconds: null,
    devOtp: null,
    token: storedToken,
    isAuthenticated: !!storedToken,
};

const authSlice = createSlice({
    name: "auth",

    initialState,

    reducers: {

        setOtpSession(
            state,
            action: PayloadAction<{
                otpToken: string;
                expiresInSeconds: number;
                devOtp?: string;
            }>
        ) {
            state.otpToken =
                action.payload.otpToken;

            state.expiresInSeconds =
                action.payload.expiresInSeconds;

            state.devOtp =
                action.payload.devOtp ?? null;
        },

        setAuthToken(
            state,
            action: PayloadAction<string>
        ) {
            state.token =
                action.payload;

            state.isAuthenticated =
                true;

            localStorage.setItem(
                "journey_token",
                action.payload
            );
        },

        clearOtpSession(state) {
            state.otpToken = null;
            state.expiresInSeconds = null;
            state.devOtp = null;
        },

        clearAuth(state) {

            state.otpToken = null;
            state.expiresInSeconds = null;
            state.devOtp = null;
            state.token = null;
            state.isAuthenticated = false;

            localStorage.removeItem(
                "journey_token"
            );
        },

    },
});

export const {
    setOtpSession,
    setAuthToken,
    clearOtpSession,
    clearAuth,
} = authSlice.actions;

export default authSlice.reducer;